/**
 * Screen Wake Lock - keeps the screen on during game sessions.
 * Re-acquires on tab visibility change (browser releases it automatically).
 */

let listenerRegistered = false;

async function acquireLock(): Promise<void> {
  try {
    if ('wakeLock' in navigator) {
      await navigator.wakeLock.request('screen');
    }
  } catch {
    // Permission denied or not supported
  }
}

function onVisibility() {
  if (!document.hidden) acquireLock();
}

export async function requestWakeLock(): Promise<boolean> {
  await acquireLock();
  if (!listenerRegistered) {
    document.addEventListener('visibilitychange', onVisibility);
    listenerRegistered = true;
  }
  return 'wakeLock' in navigator;
}
